import { UserDetails } from "../types/userTypes";
import { contactAddressInitialValues } from "./base/address/contactAddressInitialValues";
import { receiverAddressInitialValues } from "./base/address/receiverAddressInitialValues";
import { baseUserInitialValues } from "./base/user/baseUserInitialValues";

export const userDataAdminUpdateInitialValues: UserDetails = {
  email: baseUserInitialValues.email,
  emailVerified: baseUserInitialValues.emailVerified,
  enabled: baseUserInitialValues.enabled,
  password: baseUserInitialValues.password,
  username: baseUserInitialValues.username,
  firstName: baseUserInitialValues.firstName,
  middleName: baseUserInitialValues.middleName,
  lastName: baseUserInitialValues.lastName,
  personalIdType: baseUserInitialValues.personalIdType,
  personalId: baseUserInitialValues.personalId,
  personalNacidId: baseUserInitialValues.personalNacidId,
  foreignerIdentifierKind: baseUserInitialValues.foreignerIdentifierKind,
  foreignerIdentifierCountry: baseUserInitialValues.foreignerIdentifierCountry,
  birthCountry: baseUserInitialValues.birthCountry,
  birthPlace: baseUserInitialValues.birthPlace,
  birthSettlement: baseUserInitialValues.birthSettlement,
  citizenship: baseUserInitialValues.citizenship,
  dateOfBirth: baseUserInitialValues.dateOfBirth,
  isRepresentative: baseUserInitialValues.isRepresentative,
  representativeType: baseUserInitialValues.representativeType,
  representedUniversity: baseUserInitialValues.representedUniversity,
  representedCompany: baseUserInitialValues.representedCompany,
  contactAddress: contactAddressInitialValues,
  resultReceive: baseUserInitialValues.resultReceive,
  receiverAddress: receiverAddressInitialValues,
};
